import { faHashtag } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function PageHeader({ title, desc }) {
  return (
    <header className='title-box mb-10 p-4 lg:mb-20 lg:px-12 lg:py-6'>
      <h1 className='mb-3 text-2xl text-slate-700 font-bold lg:mb-8 lg:text-4xl'>
        <FontAwesomeIcon icon={faHashtag} className='mr-3' />
        {title}
      </h1>
      <p className='flex item-center mb-0 ml-8 text-sm text-slate-500 font-normal lg:font-bold lg:ml-12 lg:text-xl'>
        {desc}
      </p>
    </header>
  )
}
